(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Nav collapse on scroll + hero overlap detection
  var header = document.querySelector('.header');
  var container = header && header.querySelector('.header-container');
  if (!header || !container) return;

  var announcementBar = document.querySelector('announcement-bar');
  var lastScrollY = 0;

  function handleScroll() {
    var currentScrollY = window.scrollY;

    var hero = document.querySelector('.hero-banner');
    if (hero) {
      var heroBottom = hero.offsetTop + hero.offsetHeight;
      if (currentScrollY < heroBottom - 100) {
        header.classList.add('over-hero');
      } else {
        header.classList.remove('over-hero');
      }
    }

    if (currentScrollY > 50) {
      if (currentScrollY > lastScrollY) {
        container.classList.add('nav-hidden');
        if (announcementBar) announcementBar.classList.add('is-hidden');
      } else {
        container.classList.remove('nav-hidden');
        if (announcementBar) announcementBar.classList.remove('is-hidden');
      }
    } else {
      container.classList.remove('nav-hidden');
      if (announcementBar) announcementBar.classList.remove('is-hidden');
    }

    lastScrollY = currentScrollY;
  }

  var headerGroup = header.closest('.header-group') || header;

  // Only measure when the header-group is in its fully expanded resting state.
  // Why: scroll toggles .nav-hidden / .is-hidden which animate height via CSS
  // transition. iOS fires resize during scroll-up (URL bar), which would
  // otherwise capture a mid-transition or collapsed offsetHeight and snap the
  // CSS var, causing layout shift in any consumer using --header-height
  // (intro padding, hero min-height, sticky tabs).
  function updateHeaderHeight() {
    if (container.classList.contains('nav-hidden')) return;
    var bar = headerGroup.querySelector('announcement-bar');
    if (bar && bar.classList.contains('is-hidden')) return;
    document.documentElement.style.setProperty('--header-height', headerGroup.offsetHeight + 'px');
  }

  window.addEventListener('resize', updateHeaderHeight, { passive: true });
  new MutationObserver(updateHeaderHeight).observe(headerGroup, { childList: true, subtree: true });

  // Re-measure once the expand transition completes so a resize-while-scrolled
  // is reconciled when the user returns to the top.
  headerGroup.addEventListener('transitionend', function (e) {
    if (e.propertyName === 'grid-template-rows' || e.propertyName === 'max-height') {
      updateHeaderHeight();
    }
  });

  updateHeaderHeight();

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var tagWrapper = document.querySelector('[data-color-tag]');
    if (!tagWrapper) return;

    var trigger = tagWrapper.querySelector('[data-color-trigger]');
    var popover = tagWrapper.querySelector('[data-color-popover]');
    if (!trigger || !popover) return;

    var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    function show() {
      popover.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function hide() {
      popover.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    if (!isTouch) {
      tagWrapper.addEventListener('mouseenter', show);
      tagWrapper.addEventListener('mouseleave', hide);
    }

    trigger.addEventListener('click', function () {
      if (popover.classList.contains('is-open')) {
        hide();
      } else {
        show();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  function initTabsSection(section) {
    var tablist = section.querySelector('[role="tablist"]');
    if (!tablist) return;

    var panels = section.querySelectorAll('[role="tabpanel"]');
    if (!panels.length) return;

    tablist.innerHTML = '';

    panels.forEach(function(panel) {
      var button = document.createElement('button');
      button.className = 'tabs-button';
      button.setAttribute('role', 'tab');
      button.setAttribute('id', panel.getAttribute('aria-labelledby'));
      button.setAttribute('aria-selected', 'false');
      button.setAttribute('aria-controls', panel.id);
      button.setAttribute('tabindex', '-1');
      button.setAttribute('data-tab-slug', panel.getAttribute('data-tab-slug') || '');

      var imageUrl = panel.getAttribute('data-tab-image');
      if (imageUrl) {
        var img = document.createElement('img');
        img.className = 'tabs-button-image';
        img.src = imageUrl;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 40;
        img.height = 40;
        button.appendChild(img);
      }

      var label = document.createTextNode(panel.getAttribute('data-tab-heading') || '');
      button.appendChild(label);

      tablist.appendChild(button);
      panel.classList.remove('is-active');
      panel.hidden = true;
    });

    var buttons = tablist.querySelectorAll('[role="tab"]');

    function activateTab(button, updateUrl) {
      buttons.forEach(function(btn) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-selected', 'false');
        btn.setAttribute('tabindex', '-1');
      });

      panels.forEach(function(panel) {
        panel.classList.remove('is-active');
        panel.hidden = true;
      });

      button.classList.add('is-active');
      button.setAttribute('aria-selected', 'true');
      button.removeAttribute('tabindex');

      var panelId = button.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      if (panel) {
        panel.classList.add('is-active');
        panel.hidden = false;
      }

      if (updateUrl !== false) {
        var slug = button.getAttribute('data-tab-slug');
        if (slug) {
          var url = new URL(window.location);
          url.searchParams.set('tab', slug);
          history.replaceState({}, '', url);
        }
      }
    }

    /* Determine initial tab from URL query param */
    var initialIndex = 0;
    var tabParam = new URLSearchParams(window.location.search).get('tab');
    if (tabParam) {
      buttons.forEach(function(btn, i) {
        if (btn.getAttribute('data-tab-slug') === tabParam) {
          initialIndex = i;
        }
      });
    }

    activateTab(buttons[initialIndex], false);

    buttons.forEach(function(button) {
      button.addEventListener('click', function() {
        activateTab(button);
      });
    });

    /* Keyboard navigation */
    tablist.addEventListener('keydown', function(e) {
      var index = Array.prototype.indexOf.call(buttons, document.activeElement);
      if (index === -1) return;

      var newIndex;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        newIndex = (index + 1) % buttons.length;
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        newIndex = (index - 1 + buttons.length) % buttons.length;
      } else if (e.key === 'Home') {
        newIndex = 0;
      } else if (e.key === 'End') {
        newIndex = buttons.length - 1;
      } else {
        return;
      }

      e.preventDefault();
      buttons[newIndex].focus();
      activateTab(buttons[newIndex]);
    });
  }

  document.querySelectorAll('.tabs-section').forEach(initTabsSection);

  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target;
    if (section.classList.contains('tabs-section')) {
      initTabsSection(section);
    }
  });

  document.addEventListener('shopify:block:select', function(e) {
    var section = e.target.closest('.tabs-section');
    if (!section) return;

    var panel = e.target.closest('[role="tabpanel"]');
    if (!panel) return;

    var tabId = panel.getAttribute('aria-labelledby');
    var button = section.querySelector('#' + tabId);
    if (button) button.click();
  });

  } catch(e) { console.error(e); }
})();
})();
